import {
  EditEducationClass,
  educationParallelTextRepresentation,
  CopyEducationClass,
  DeleteEducationClass,
} from 'entities/education-class';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { getShiftTextRepresentation } from 'shared/utils';
import type { EducationClass, Parallel, SHIFT } from 'shared/api';
import type { ColumnsType } from 'antd/es/table';

export const getEducationClassesTableColumns = (): ColumnsType<EducationClass> => [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
    width: '10rem',
    sorter: true,
  },
  {
    key: 'parallel',
    title: 'Параллель',
    dataIndex: 'parallel',
    sorter: true,
    render: (value: Parallel) => {
      return educationParallelTextRepresentation[value as Parallel];
    },
  },
  {
    key: 'litera',
    title: 'Литера',
    dataIndex: 'litera',
    sorter: true,
  },
  {
    key: 'shift',
    title: 'Смена',
    dataIndex: 'shift',
    sorter: true,
    render: (value: SHIFT) => {
      return getShiftTextRepresentation(value);
    },
  },
  {
    key: 'includeSaturday',
    title: 'Учится в субботу',
    dataIndex: 'includeSaturday',
    sorter: true,
    render: (includeSaturday: boolean) => (includeSaturday ? 'Да' : 'Нет'),
  },
  {
    key: 'controls',
    title: '',
    dataIndex: [],
    width: '10rem',
    render: (_, record: EducationClass) => (
      <AppFlex direction="row" alignItems="center">
        <EditEducationClass selectedEducationClass={record} />
        <CopyEducationClass selectedEducationClass={record} />
        <DeleteEducationClass selectedEducationClass={record} />
      </AppFlex>
    ),
  },
];
